import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/google/cactus.png")